import { useEffect, useState } from 'react';

/**
 * El valor, pero solo después de `delay` ms sin cambios. Para los buscadores que alimentan una
 * RPC: sin esto cada tecla dispara la consulta (y la de totales, que recorre todo el universo).
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}
